const Fetcher = require('od-modules/utils/fetcher');

const VOLUNTARY = 'VOLUNTARY';
const INVOLUNTARY = 'INVOLUNTARY';

const BOOKING_CHANGE_REQUEST = '/travel/service/bookingchangerequest';

const STATUS_LIST = [
    'REFUND_REQUESTED',
    'REFUND_PRIORITISING',
    'REFUND_PROCESSING',
    'REFUND_AIRLINE_REQUESTED',
    'REFUND_AIRLINE_PENDING',
    'REFUND_AIRLINE_APPROVED',
    'REFUND_FINALIZING',
];

const TYPE_PARAMS = {
    VOLUNTARY: 'voluntaryRefundStatus',
    INVOLUNTARY: 'involuntaryRefundStatus',
};

const getTypeParam = (type) => TYPE_PARAMS[type];

const getBookingChangeRequestUrl = (type, bookingId) => `${BOOKING_CHANGE_REQUEST}/${getTypeParam(type)}/${bookingId}`;

const getBookingChangeRequest = (type, bookingId) => Fetcher.get(getBookingChangeRequestUrl(type, bookingId)).json();

class Status {
    constructor({type, bookingId, keys = {}} = {}) {
        this.keys = keys;
        this.valid = false;
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });

        getBookingChangeRequest(type, bookingId)
            .then(this.load.bind(this))
            .catch(() => this.resolve(false));
    }

    load({status} = {}) {
        this.status = status;
        this.index = STATUS_LIST.indexOf(status);
        this.valid = this.index >= 0;
        this.resolve(true);
    }

    isValid() {
        return this.valid;
    }

    then(handler = () => {}) {
        return this.promise.then(handler);
    }

    get info() {
        return this.valid
            ? {
                description: this.keys[`cancelNotificationStatus::${this.status}`],
                currentStep: this.index + 1,
                totalSteps: STATUS_LIST.length,
            }
            : {};
    }
}

module.exports = {
    Status,
    VOLUNTARY,
    INVOLUNTARY,
};
